import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="7bt-V8pPMFU"
                    title="AVM Fritzbox Network Storage Windows"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="AVM Fritzbox Network Storage Windows"
              footer={
                <EuiText>
                  <p>In diesem Video erklären wir wie Sie einen NAS / USB Speicher an der Fritzbox als Netzwerkspeicher hinzufügen können. Auf diese Weise können Sie die Aufnahmen Ihrer INSTAR IP Kamera wesentlich einfacher verwalten und alte Aufnahmen bequem löschen.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
